import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { FaHome, FaRegUser } from "react-icons/fa";
import { HiHome } from "react-icons/hi2";

function SellerRegNavbar() {
  const { isAuthenticated, logout, user } = useAuth();

  return (
    <nav className="bg-white p-4 text-base font-medium md:p-5">
      <div className="mx-auto flex max-w-7xl items-center justify-between">
        {/* Left: Logo */}
        <div>
          <Link to="/">
            <img
              src="/images/logo/seller_brix_logo.png"
              alt="logo"
              className="h-7 w-full md:h-10"
            />
          </Link>
        </div>

        {/* Center: Empty */}
        <div className="flex-1"></div>

        {/* Right: Home and Auth Buttons */}
        <div className="flex items-center space-x-4">
          <NavLink to="/" className="rounded-lg px-2 py-1 font-normal">
            <HiHome className="text-2xl text-green-500" />
          </NavLink>

          {isAuthenticated ? (
            <button
              onClick={logout}
              className="rounded-md border-2 border-gray-700 px-2 py-1 text-brand-dark hover:text-brand-primary"
            >
              Logout
            </button>
          ) : (
            <>
              <div className="flex items-center gap-5">
                {/* <div className="rounded-full border-2 border-gray-700 p-2">
                  <FaRegUser className="text-gray-700" />
                </div> */}
                {isAuthenticated ? (
                  <button
                    onClick={logout}
                    className="rounded-md border-2 border-gray-700 px-2 py-1 text-brand-dark hover:text-brand-primary"
                  >
                    Logout
                  </button>
                ) : (
                  <NavLink to="/seller/login/email">
                    <button className="rounded-md border-2 border-gray-700 px-2 py-1 text-brand-dark hover:text-brand-primary">
                      Sign In
                    </button>
                  </NavLink>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default SellerRegNavbar;
